var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { useContext } from "react";
import { SliceLayoutsContext } from "../components/context/slice-layouts-context";
import * as defaultSliceLayouts from '../components/slice-layouts';
export var useSliceLayouts = function useSliceLayouts() {
  var custom = useContext(SliceLayoutsContext) || {};
  return __assign(__assign({}, defaultSliceLayouts), custom);
};